import styled from "styled-components";

export const Underline = styled.span`
  text-decoration: underline;
  font-weight: bold;

  :hover {
    cursor: pointer;
  }
`;